var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcThunder20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.684 1.783 4.075 9.317c-.558.566-.2 1.6.567 1.6h4.342c.525 0 .916.483.816 1l-1.175 5.858c-.091.442.392.742.692.442l6.608-7.534c.559-.566.2-1.6-.566-1.6h-4.342a.837.837 0 0 1-.817-1l1.175-5.858c.092-.442-.391-.742-.691-.442Z",
  fill: "#2D91FF"
})));
export default SvgIcThunder20X20;